import "./register.css";
import axios from "axios";
import { useRef } from "react";
import { useNavigate } from "react-router-dom";

export default function Register() {
  const username = useRef();
  const email = useRef();
  const password = useRef();
  const passwordAgain = useRef();
  const navigate = useNavigate();

  const handleClick = async (e) => {
    e.preventDefault();
    if (passwordAgain.current.value !== password.current.value) {
      passwordAgain.current.setCustomValidity("Passwords don't match!");
    } else {
      const user = {
        username: username.current.value,
        email: email.current.value,
        password: password.current.value,
      };
      try {
        await axios.post("https://conexus-api.vercel.app/api/auth/register", user);
        navigate("/login");
      } catch (err) {
        console.log(err);
      }
    }
  };

  return (
    <>
      <div className="registerWrapper">
        <div className="registerLeft">
          <h3 className="registerLogo">Conexus</h3>
          <span className="registerDesc">
            Connect with friends, connect with the world, connect with us.
          </span>
        </div>
        <div className="registerRight">
          <form className="registerBox" onSubmit={handleClick}>
            <h1 className="registerHeader">Register</h1>
            <input
              placeholder="Username"
              required
              ref={username}
              className="registerInput"
            />
            <input
              placeholder="Email"
              required
              ref={email}
              className="registerInput"
              type="email"
            />
            <input
              placeholder="Password"
              required
              ref={password}
              className="registerInput"
              type="password"
              minLength="6"
              maxLength="20"
            />
            <input
              placeholder="Password Again"
              required
              ref={passwordAgain}
              className="registerInput"
              type="password"
            />
            <button className="registerButton blue buttonSfx" type="submit">
              <span>Sign up</span>
            </button>
            <button type="button" onClick={() => {navigate("../login")}} className="registerLoginButton green buttonSfx">
              <span>Log in</span>
            </button>
          </form>
        </div>
      </div>
    </>
  );
}
